import { IconLayoutDashboard } from '@tabler/icons-react';
import { createFileRoute } from '@tanstack/react-router';

import { Bookmarks } from '#core/components/bookmarks/Bookmarks.tsx';
import type { Bookmark } from '#core/components/bookmarks/types.ts';
import { type DashboardBookmark, useDashboardBookmarks } from '#core/hooks/useDashboardBookmarks.ts';

export const Route = createFileRoute('/bookmarks')({
  component: RouteComponent,
  beforeLoad: () => ({
    getTitle: () => 'Bookmarks',
  }),
});

function RouteComponent() {
  const [bookmarks, setBookmarks] = useDashboardBookmarks();

  const bookmarksWithIcons: Bookmark<DashboardBookmark>[] = bookmarks.map((data) => ({
    id: data.title ?? '',
    title: data.title ?? 'Unnamed Dashboard',
    icon: <IconLayoutDashboard size={16} />,
    data,
  }));

  const handleDelete = (bookmark: Bookmark<DashboardBookmark>) => {
    setBookmarks((current) => current.filter((item) => item.title !== bookmark.id));
  };

  return <Bookmarks bookmarks={bookmarksWithIcons} onDelete={handleDelete} title="My Dashboards" />;
}
